/**
 * @file WallController
 * @description
 * Load into your application like `myApp.controller('WallController', require('WallController.js'))`
 */
module.exports = ["$scope", "DataService", "AppConstants", "ChannelRepository", "$q", function($scope, DataService, AppConstants, ChannelRepository, $q) {
    const _controller = this;

    let _totalCount = '    ';
    const _counterLength = _totalCount.length;


    /**
     * Load the next page
     */
    _controller.loadCount = () => {
        DataService.totalCount().then((count) => {
            _totalCount = count;
        });
    };

    _controller.count = () => {
        let count = `${_totalCount}`;

        while(count.length < _counterLength) {
            count = `0${count}`;
        }

        return count.split('');
    };

    (function init() {
        _controller.loadCount();
    }());
}];
